import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getIsFetchingCopyLocal,
  getPublishedUnpublishedPpsis
} from '../selectors';
import { fetchPublishedUnpublishedPpsis } from '../actions';

const useCopyLocalPpsis = () => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetchingCopyLocal);
  const ppsis = useSelector(getPublishedUnpublishedPpsis);

  useEffect(() => {
    dispatch(fetchPublishedUnpublishedPpsis());
  }, [dispatch]);

  return [isFetching, ppsis];
};

export default useCopyLocalPpsis;
